<template>
  <DsShowcase title="TabsPlayV2" description="Componente de abas com named slots, ícones, tabs desabilitadas e ocultas.">
    <!-- PROP: tabs + modelValue -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">tabs / v-model</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>tabs: Array&lt;{ id, label, icon? }&gt;</code> — <code>v-model: string</code> (id da aba ativa). Conteúdo via named slots.</p>
      <div class="tw:max-w-2xl">
        <TabsPlayV2 v-model="tab1" :tabs="basicTabs">
          <template #geral>
            <p class="tw:text-sm">Conteúdo da aba <strong>Geral</strong></p>
          </template>
          <template #avancado>
            <p class="tw:text-sm">Conteúdo da aba <strong>Avançado</strong></p>
          </template>
          <template #integracao>
            <p class="tw:text-sm">Conteúdo da aba <strong>Integração</strong></p>
          </template>
        </TabsPlayV2>
      </div>
    </section>

    <!-- PROP: tabs com icon -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Com ícones</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>icon: string</code> — ícone Material Symbols à esquerda do label</p>
      <div class="tw:max-w-2xl">
        <TabsPlayV2 v-model="tab2" :tabs="iconTabs">
          <template #overview>
            <p class="tw:text-sm">Visão geral do projeto</p>
          </template>
          <template #members>
            <p class="tw:text-sm">Lista de membros</p>
          </template>
          <template #settings>
            <p class="tw:text-sm">Configurações do projeto</p>
          </template>
        </TabsPlayV2>
      </div>
    </section>

    <!-- PROP: disabledTabs -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabledTabs</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string[]</code> — IDs das abas desabilitadas</p>
      <div class="tw:max-w-2xl">
        <TabsPlayV2 v-model="tab3" :tabs="basicTabs" :disabled-tabs="['integracao']">
          <template #geral>
            <p class="tw:text-sm">Aba geral ativa</p>
          </template>
          <template #avancado>
            <p class="tw:text-sm">Aba avançado ativa</p>
          </template>
          <template #integracao>
            <p class="tw:text-sm">Não deveria aparecer</p>
          </template>
        </TabsPlayV2>
        <p class="tw:text-xs tw:mt-2 tw:opacity-50">A aba "Integração" está desabilitada</p>
      </div>
    </section>

    <!-- PROP: hiddenTabs -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">hiddenTabs</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string[]</code> — IDs das abas ocultas</p>
      <div class="tw:max-w-2xl">
        <TabsPlayV2 v-model="tab4" :tabs="basicTabs" :hidden-tabs="['avancado']">
          <template #geral>
            <p class="tw:text-sm">Apenas Geral e Integração visíveis</p>
          </template>
          <template #integracao>
            <p class="tw:text-sm">Integração</p>
          </template>
        </TabsPlayV2>
      </div>
    </section>

    <!-- PROP: textSize -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">textSize</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — tamanho do texto das abas. Padrão: <code>'base'</code></p>
      <div class="tw:max-w-2xl tw:space-y-6">
        <TabsPlayV2 v-model="tab5a" :tabs="basicTabs" text-size="sm">
          <template #geral><p class="tw:text-sm">sm</p></template>
          <template #avancado><p class="tw:text-sm">sm</p></template>
          <template #integracao><p class="tw:text-sm">sm</p></template>
        </TabsPlayV2>
        <TabsPlayV2 v-model="tab5b" :tabs="basicTabs" text-size="lg">
          <template #geral><p class="tw:text-sm">lg</p></template>
          <template #avancado><p class="tw:text-sm">lg</p></template>
          <template #integracao><p class="tw:text-sm">lg</p></template>
        </TabsPlayV2>
      </div>
    </section>

    <!-- PROP: skeleton -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">skeleton</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code></p>
      <div class="tw:max-w-2xl">
        <TabsPlayV2 :tabs="basicTabs" :skeleton="true" model-value="geral">
          <template #geral />
        </TabsPlayV2>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { TabsPlayV2 } from "@/components/atomic"

const basicTabs = [
  { id: 'geral', label: 'Geral' },
  { id: 'avancado', label: 'Avançado' },
  { id: 'integracao', label: 'Integração' },
]

const iconTabs = [
  { id: 'overview', label: 'Visão geral', icon: 'dashboard' },
  { id: 'members', label: 'Membros', icon: 'group' },
  { id: 'settings', label: 'Configurações', icon: 'settings' },
]

const tab1 = ref('geral')
const tab2 = ref('overview')
const tab3 = ref('geral')
const tab4 = ref('geral')
const tab5a = ref('geral')
const tab5b = ref('geral')
</script>
